<template>
    <div>
        <v-row class="py-3 px-1">
            {{(StateAvaliacoesTempoCasa||{}).count || 0}} Registros
            <v-spacer></v-spacer>
            <v-btn color="secondary" elevation="0"
                @click.prevent="getAvaliacoes"
                :loading="StateRHLoading.includes('avaliacoes-tempo-casa')">
                <v-icon small>mdi-sync</v-icon> Atualizar
            </v-btn>
        </v-row>
        <v-row class="mb-1">
            <v-text-field label="Pesquisar"
                v-model="params.q"
                @keyup.enter="getAvaliacoes"
                clearable hide-details></v-text-field>
            <v-select :items="filtros.enviados"
                v-model="params.enviados"
                hide-details
                label="Enviados"
                ></v-select>
            <v-select :items="filtros.concluidos"
                v-model="params.concluidos"
                hide-details
                label="Concluídos"
                ></v-select>
            <v-select :items="filtros.tags"
                v-model="params.tag"
                hide-details
                label="Classificador"
                ></v-select>
            
        </v-row>
        <div v-for="aval, i in (StateAvaliacoesTempoCasa||{}).results || []" :key="i">
            <ItemAvaliacao :avaliacao="aval" @on-updated="getAvaliacoes"/>
        </div>
        <v-row class="py-3 px-1">
            <v-btn color="secondary" elevation="0"
                @click.prevent="loadMore(StateAvaliacoesTempoCasa.previous)"
                :disabled="!StateAvaliacoesTempoCasa.previous">
                <v-icon small>mdi-arrow-left</v-icon> &nbsp; Mais antiga
            </v-btn>
            <v-btn color="secondary" elevation="0"
                @click.prevent="loadMore(StateAvaliacoesTempoCasa.next)"
                :disabled="!StateAvaliacoesTempoCasa?.next">
                Mais recente &nbsp; <v-icon small>mdi-arrow-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-select :items="[10, 25, 50, 100]"
                v-model="params.page_size"
                hide-details
                label="Resultados por página"
                >
            </v-select>
            
        </v-row>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ConfigService from '@/services/index'
import ItemAvaliacao from './ItemAvaliacao.vue'

const configService = new ConfigService()
export default {
    components: {
        ItemAvaliacao
    },
    data:()=>({
        params: {
            q: null,
            page_size: 10,
            enviados: null,
            concluidos: 0,
            tag: null
        },
        filtros: {
            enviados: [
                {value: null, title: 'Todos'},
                {value: 0, title: 'Não enviados'},
                {value: 1, title: 'Enviados'},
            ],
            concluidos: [
                {value: null, title: 'Todos'},
                {value: 0, title: 'Pendentes'},
                {value: 1, title: 'Concluídos'},
            ],
            tags: [
                {value: null, title: 'Todos'},
                {value: '30D', title: '30 dias'},
                {value: '60D', title: '60 Dias'},
                {value: '90D', title: '90 Dias'},
                {value: '180D', title: '180 Dias'},
            ]
        }
    }),
    mounted(){
        this.getAvaliacoes()
    },
    methods:{
        ...mapActions(['GetAvaliacoesTempoCasa']),
        ...mapMutations(['SetAvaliacoesTempoCasa']),
        async loadMore(url){
            let response = await configService.genericGetRequest(url, this.params)
            var data = {...response.data, ...this.params }
            this.SetAvaliacoesTempoCasa(data)
        },
        getAvaliacoes(){
            this.GetAvaliacoesTempoCasa(this.params)
        }
    },
    computed:{
        ...mapGetters(['StateAvaliacoesTempoCasa','StateRHLoading',])
    },
    watch:{
        // page_size(){
        //     this.getAvaliacoes()
        // }
    }
}
</script>